var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWatsapp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.431,
    height: 18.461,
    viewBox: "0 0 36.431 36.461",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8299",
    "data-name": "Group 8299",
    transform: "translate(16269.358 19315.228)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16048",
    "data-name": "Path 16048",
    d: "M157.16,46.326c.97-2.5,1.839-4.8,2.768-7.081a1.653,1.653,0,0,0-.143-1.645,18.213,18.213,0,1,1,18.433,8.541,17.512,17.512,0,0,1-12.328-2.421,1.569,1.569,0,0,0-1.571-.135c-2.058.835-4.135,1.621-6.207,2.422-.244.094-.5.167-.952.32m7.89-24.076a9.731,9.731,0,0,0,1.224,4.2,26.422,26.422,0,0,0,6.907,8.213,16.616,16.616,0,0,0,6.886,3.677,3.806,3.806,0,0,0,4.905-2.551q.262-.638.506-1.284a1.267,1.267,0,0,0-.631-1.84c-1.045-.626-2.1-1.229-3.168-1.823-.889-.5-1.392-.368-2.006.471a2.579,2.579,0,0,1-4.068.539,40.846,40.846,0,0,1-3.7-3.638c-1.5-1.687-1.31-3.095.467-4.466a1.225,1.225,0,0,0,.406-1.711c-.639-1.163-1.308-2.308-1.978-3.454a1.25,1.25,0,0,0-1.736-.558c-.6.248-1.2.495-1.808.728a3.4,3.4,0,0,0-2.209,3.5",
    transform: "translate(-16426.492 -19325.17)",
    fill: "#5aa2fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16049",
    "data-name": "Path 16049",
    d: "M177.989,35.218a3.4,3.4,0,0,1,2.209-3.5c.606-.233,1.207-.48,1.808-.728a1.25,1.25,0,0,1,1.736.558c.67,1.146,1.339,2.291,1.977,3.454a1.225,1.225,0,0,1-.406,1.711c-1.777,1.371-1.971,2.78-.467,4.466a40.845,40.845,0,0,0,3.7,3.638,2.579,2.579,0,0,0,4.068-.539c.614-.838,1.117-.967,2.006-.471,1.064.594,2.123,1.2,3.168,1.823a1.266,1.266,0,0,1,.631,1.84q-.243.646-.506,1.284a3.806,3.806,0,0,1-4.905,2.551,16.616,16.616,0,0,1-6.886-3.677,26.422,26.422,0,0,1-6.907-8.213,9.731,9.731,0,0,1-1.224-4.2",
    transform: "translate(-16439.432 -19338.139)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatsapp);
export default __webpack_public_path__ + "static/media/watsapp.b691dba50fc1ed91678984b057ee125c.svg";
export { ForwardRef as ReactComponent };